let body = document.querySelector('body'),
  html = document.querySelector('html'),
  productCheck = body.classList.contains('template-product'),
  blogCheck = body.classList.contains('template-blog');

  function PopoverCloseDisabled() {
    const popover = document.querySelector('.js-fix-on-scroll[popover]');

    // Prevent closing when clicking outside
    document.addEventListener('click', (event) => {
      if (!popover.contains(event.target)) {
        event.preventDefault(); // Prevent the default closing behavior
        console.log('Popover is open, but not closing.');
      } else {
        console.log('Popover is open and clicking within.');
      }
    });
  }
  function fixedAddToCart() {
    let formContainer = document.querySelector('.product-custom product-info');

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.querySelector('.js-fix-on-scroll').classList.remove('js-fixed');
            html.classList.remove('fixed-add-to-cart');
            // entry.target.querySelector('.js-fix-on-scroll .product-form__submit span').textContent = 'Add to Cart';
            entry.target.querySelector('.js-fix-on-scroll').removeAttribute('popover');
          } else {
            entry.target.querySelector('.js-fix-on-scroll').classList.add('js-fixed');
            html.classList.add('fixed-add-to-cart');
            entry.target.querySelector('.js-fix-on-scroll').setAttribute('popover', 'manual');
            // entry.target.querySelector('.js-fix-on-scroll .product-form__submit span').textContent = 'Buy Now';
            entry.target.querySelector('.js-fix-on-scroll').showPopover();
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      },
    );

    observer.observe(formContainer);
  }


function keyframeObserver() {
  let keyframes = document.querySelectorAll('.keyframes--reveal'),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.classList.add('keyframes--reveal--animate');
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

  keyframes.forEach((keyframe) => {
    observer.observe(keyframe);
  });
}

function blogScroll() {
  let blogContainer = document.querySelector('.blog-articles');

  let infScroll = new InfiniteScroll(blogContainer, {
    // options
    path: '.pagination__item--prev',
    append: '.blog-articles__article',
    history: true,
    hideNav: '.pagination-wrapper',
    button: '.view-more-button',
    scrollThreshold: false,
  });

  infScroll.on('append', function () {
    html.classList.add('inf-scroll-active');
    keyframeObserver();
  });
}

function calculator() {
  document.getElementById('calculate').addEventListener('click', function (event) {
    event.preventDefault();

    // Get the input values
    var years = document.getElementById('years').value;
    var years = parseInt(years);
    var months = document.getElementById('months').value;
    var months = parseInt(months);
    var product = document.getElementById('product').value;
    var numProducts = document.getElementById('numProducts').value;
    var numProducts = parseInt(numProducts);
    var totalMonths = years * 12 + months;

    // Calculate the results
    var carbonSaved = calculateCarbonSaved(totalMonths, product, numProducts);
    var moneySaved = calculateMoneySaved(totalMonths, product, numProducts);
    var padsSaved = calculatePadsSaved(totalMonths, product, numProducts);
    var plasticSaved = calculatePlasticSaved(totalMonths, product, numProducts);

    // Display the results
    document.getElementById('carbonSaved').textContent = carbonSaved;
    document.getElementById('moneySaved').textContent = moneySaved;
    document.getElementById('padsSaved').textContent = padsSaved;
    document.getElementById('plasticSaved').textContent = plasticSaved;

    document.getElementById('results').style.display = 'grid';
  });

  function calculateCarbonSaved(totalMonths, product, numProducts) {
    // Assuming 1 product replaces 1 pad/tampon per month
    let carbon = (totalMonths * numProducts * 0.037).toFixed(3);

    return carbon + 'kg'; // CO2 saved in kg
  }

  function calculateMoneySaved(totalMonths, product, numProducts) {
    // Assuming 1 product replaces 1 pad/tampon per month
    // return years * 12 * numProducts * 0.2; // Money saved in £
    let rupees = (totalMonths * numProducts * 6).toFixed(2),
      pounds = (totalMonths * numProducts * 0.26).toFixed(2);

    if (document.getElementById('moneySaved').dataset.currency == 'in') {
      // If currency is INR
      return 'Rs.' + rupees;
    } else {
      return '£' + pounds;
    }
  }

  function calculatePadsSaved(totalMonths, product, numProducts) {
    // Assuming 1 product replaces 1 pad/tampon per month
    console.log(totalMonths);
    return totalMonths * numProducts; // Number of pads/tampons saved
  }

  function calculatePlasticSaved(totalMonths, product, numProducts) {
    // Assuming 1 product replaces 1 pad/tampon per month
    let plastic = (totalMonths * numProducts * 0.015).toFixed(3);
    return plastic + 'kg'; // Plastic waste saved in kg
  }
}

if (document.getElementById('calculate')) {
  calculator();
}






keyframeObserver();

if (blogCheck) {
  console.log('blog page');
  blogScroll();
}

if (productCheck) {
  console.log('product page');
  fixedAddToCart();
}

function hideProductModal() {
  // Your code here
  keyframeObserver();

  if (blogCheck) {
    console.log('blog page');
    blogScroll();
  }

  if (productCheck) {
    console.log('product page');
    fixedAddToCart();
  }
}

document.addEventListener('shopify:section:reorder', () => editorFunctions());

document.addEventListener('shopify:section:select', () => editorFunctions());

document.addEventListener('shopify:section:deselect', () => editorFunctions());

document.addEventListener('shopify:inspector:activate', () => editorFunctions());

document.addEventListener('shopify:inspector:deactivate', () => editorFunctions());
